// data-testid registry for the Brand Kit (M2.5) screens.
export const BRAND_KIT = {
  pageRoot: "brand-kit-page",
  tabLogos: "brand-kit-tab-logos",
  tabColors: "brand-kit-tab-colors",
  tabFonts: "brand-kit-tab-fonts",
  tabShapes: "brand-kit-tab-shapes",
  tabLibrary: "brand-kit-tab-library",
  tabTemplates: "brand-kit-tab-templates",
  tabAssets: "brand-kit-tab-assets",
  tabRules: "brand-kit-tab-rules",
  tabContent: "brand-kit-tab-content",

  // Templates (M3.1 → M6.1 link to document types)
  templatesList: "brand-kit-templates-list",
  templatesEmpty: "brand-kit-templates-empty",
  templateRowPrefix: "brand-kit-template-row-",
  templateDocTypeSelectPrefix: "brand-kit-template-doctype-",

  // Logos
  logosList: "brand-kit-logos-list",
  logosEmpty: "brand-kit-logos-empty",
  logoAddButton: "brand-kit-logo-add",
  logoRowPrefix: "brand-kit-logo-row-",
  logoEditPrefix: "brand-kit-logo-edit-",
  logoDeletePrefix: "brand-kit-logo-delete-",
  logoNameInput: "brand-kit-logo-name-input",
  logoVariantSelect: "brand-kit-logo-variant-select",
  logoNotesInput: "brand-kit-logo-notes-input",
  logoClearSpaceInput: "brand-kit-logo-clearspace-input",
  logoMinWidthInput: "brand-kit-logo-minwidth-input",
  logoBackgroundsInput: "brand-kit-logo-backgrounds-input",
  logoSubmit: "brand-kit-logo-submit",
  logoCancel: "brand-kit-logo-cancel",
  logoPriorityInput: "brand-kit-logo-priority-input",
  logoBindingPrefix: "brand-kit-logo-binding-",
  logoCategoryPrefix: "brand-kit-logo-category-",
  logoAllowedBgPrefix: "brand-kit-logo-allowedbg-",

  // Colors
  colorsList: "brand-kit-colors-list",
  colorsEmpty: "brand-kit-colors-empty",
  colorAddButton: "brand-kit-color-add",
  colorRowPrefix: "brand-kit-color-row-",
  colorEditPrefix: "brand-kit-color-edit-",
  colorDeletePrefix: "brand-kit-color-delete-",
  colorNameInput: "brand-kit-color-name-input",
  colorHexInput: "brand-kit-color-hex-input",
  colorCmykInput: "brand-kit-color-cmyk-input",
  colorPantoneInput: "brand-kit-color-pantone-input",
  colorRoleTogglePrefix: "brand-kit-color-role-",
  colorDescInput: "brand-kit-color-desc-input",
  colorSubmit: "brand-kit-color-submit",
  colorCancel: "brand-kit-color-cancel",
  colorPriorityInput: "brand-kit-color-priority-input",
  colorAllowedBgPrefix: "brand-kit-color-allowedbg-",
  colorContrastPrefix: "brand-kit-color-contrastvs-",
  colorCategoryPrefix: "brand-kit-color-category-",

  // Fonts
  fontsList: "brand-kit-fonts-list",
  fontsEmpty: "brand-kit-fonts-empty",
  fontAddButton: "brand-kit-font-add",
  fontRowPrefix: "brand-kit-font-row-",
  fontEditPrefix: "brand-kit-font-edit-",
  fontDeletePrefix: "brand-kit-font-delete-",
  fontNameInput: "brand-kit-font-name-input",
  fontFamilyInput: "brand-kit-font-family-input",
  fontWeightTogglePrefix: "brand-kit-font-weight-",
  fontItalicToggle: "brand-kit-font-italic-toggle",
  fontRoleTogglePrefix: "brand-kit-font-role-",
  fontFoundryInput: "brand-kit-font-foundry-input",
  fontLicenseInput: "brand-kit-font-license-input",
  fontSubmit: "brand-kit-font-submit",
  fontCancel: "brand-kit-font-cancel",
  fontPriorityInput: "brand-kit-font-priority-input",
  fontCategoryPrefix: "brand-kit-font-category-",

  // Shapes
  shapesList: "brand-kit-shapes-list",
  shapesEmpty: "brand-kit-shapes-empty",
  shapeAddButton: "brand-kit-shape-add",
  shapeRowPrefix: "brand-kit-shape-row-",
  shapeEditPrefix: "brand-kit-shape-edit-",
  shapeDeletePrefix: "brand-kit-shape-delete-",
  shapeNameInput: "brand-kit-shape-name-input",
  shapeDescInput: "brand-kit-shape-desc-input",
  shapeSubmit: "brand-kit-shape-submit",
  shapeCancel: "brand-kit-shape-cancel",
  shapePriorityInput: "brand-kit-shape-priority-input",
  shapeBindingPrefix: "brand-kit-shape-binding-",
  shapeCategoryPrefix: "brand-kit-shape-category-",

  // Library (lightweight image pool for AI agent)
  libraryList: "brand-kit-library-list",
  libraryEmpty: "brand-kit-library-empty",
  libraryAddButton: "brand-kit-library-add",
  libraryUploadInput: "brand-kit-library-upload-input",
  librarySubjectInput: "brand-kit-library-subject-input",
  librarySubjectChipPrefix: "brand-kit-library-subject-chip-",
  libraryAltInput: "brand-kit-library-alt-input",
  libraryNotesInput: "brand-kit-library-notes-input",
  librarySubmit: "brand-kit-library-submit",
  libraryCancel: "brand-kit-library-cancel",
  libraryRowPrefix: "brand-kit-library-row-",
  libraryDeletePrefix: "brand-kit-library-delete-",
  librarySectionPrefix: "brand-kit-library-section-",
};

// Stable enum-style option lists used by the Brand Kit UI. These mirror the
// pydantic Literals in /app/backend/brandkit_models.py.
export const LOGO_VARIANTS = [
  { value: "primary_lockup", label: "Primary lockup" },
  { value: "wordmark", label: "Wordmark" },
  { value: "mark", label: "Mark / Icon" },
  { value: "monochrome_dark", label: "Monochrome — dark" },
  { value: "monochrome_light", label: "Monochrome — light" },
  { value: "reversed", label: "Reversed" },
  { value: "other", label: "Other" },
];

export const COLOR_ROLES = [
  "primary",
  "secondary",
  "accent",
  "neutral",
  "background",
  "text",
  "headline",
  "body_copy",
  "primary_cta",
];

export const FONT_WEIGHTS = [
  "Thin", "Light", "Regular", "Book", "Medium",
  "Semibold", "Bold", "Black",
];

export const FONT_ROLES = [
  "headline", "subhead", "body", "disclaimer", "callout", "cta", "price",
];

// Contrast checker (Colors tab)
export const BRAND_KIT_CONTRAST = {
  root: "brand-kit-contrast",
  foregroundSelect: "brand-kit-contrast-fg",
  backgroundSelect: "brand-kit-contrast-bg",
  swapButton: "brand-kit-contrast-swap",
  preview: "brand-kit-contrast-preview",
  ratio: "brand-kit-contrast-ratio",
  aaNormal: "brand-kit-contrast-aa-normal",
  aaLarge: "brand-kit-contrast-aa-large",
  aaaNormal: "brand-kit-contrast-aaa-normal",
  aaaLarge: "brand-kit-contrast-aaa-large",
};
